import { render, staticRenderFns } from "./ApprovalWeeklyForm.vue?vue&type=template&id=1f6b615b&scoped=true&"
import script from "./ApprovalWeeklyForm.vue?vue&type=script&lang=js&"
export * from "./ApprovalWeeklyForm.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=1f6b615b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6b615b",
  null
  
)

export default component.exports